import { HTMLAttributes } from 'react'

import classNames from 'classnames'

import { getValidProps } from 'hsds/utils/react'

export const ID = 'HSDSPortalContainer'

type Props = { className?: string } & HTMLAttributes<HTMLDivElement>

const Container = (props: Props) => {
  const { className, ...rest } = props

  const componentClassName = classNames('c-PortalContainer', className)
  return <div id={ID} className={componentClassName} {...getValidProps(rest)} />
}

export default Container
